import Parse from 'parse';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AssetTopology, ParseBaseRepository } from '@telespot/infrastructure/parse';
import { apiUrl } from '@telespot/shared/environment';
import { type AssetTileSource, type AssetTileSourceProvider } from '@analysis/use-cases';
import { ApiAuthErrors } from '@telespot/web-core';

interface DziInfoResponse {
  ext: string;
  height: number;
  width: number;
  overlap: number;
  tileSize: number;
  maxNativeZoom: number;
  totalTileNumber: number;
}

@Injectable({
  providedIn: 'root',
})
export class TelespotAssetTileSourceService extends ParseBaseRepository implements AssetTileSourceProvider {
  constructor(private readonly http: HttpClient) {
    super(Parse, { useMasterKey: false });
  }

  //TODO: map to a more complete data model
  public async getTileSource(assetId: string): Promise<AssetTileSource> {
    try {
      const asset = await this.subclasses.getSubclass(AssetTopology.TABLE).createWithoutData(assetId).fetch();

      const filename = asset
        .get(AssetTopology.ASSET_FILE)
        .substring(0, asset.get(AssetTopology.ASSET_FILE).lastIndexOf('.'));

      const info = await this.http
        .get<DziInfoResponse>(`${apiUrl('pyramids')}/${filename}/info`)
        .toPromise();

      return {
        getTileUrl: (l, x, y) => `${apiUrl('pyramids')}/${filename}/${l - 1}/${y}/${x}.${info.ext}`,
        tileSize: info.tileSize ?? 512,
        width: info.width,
        height: info.height,
        tileOverlap: info.overlap ?? 0,
        minLevel: 1,
        maxLevel: info.maxNativeZoom,
        ajaxHeaders: {
          'X-Parse-Session-Token': Parse.User.current().getSessionToken(),
        },
      };
    } catch (error) {
      throw this.handleAuthError(error, ApiAuthErrors.UNAUTHORIZED);
    }
  }
}
